import React from "react"

import authentication from "@irati/auth"
import {Poll, Recognition} from "@irati/types"
import RecognitionHubViews from "@irati/recognition/constants/hubViewTypes"

import Flex from "@irati/ui/src/Flex"
import {RECOGNITION, POLL} from "@irati/recognition/constants/feedTypes"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {ReactionList} from "../Reactions"
import LikeButton from "../Reactions/LikeButton"
import ShareRecognition from "../Share"
import RewardRecognitionAction from "./RewardRecognitionAction"
import {CommentsIcon, ReactionsIcon, AddRewardIcon} from "./"

interface Props {
  item: Poll | Recognition
  type: RECOGNITION | POLL
  viewType: RecognitionHubViews
  onClickComment: () => void
  togglePickerModal: () => void
  feedItemId?: string
}

const Activity: React.FC<Props> = (props) => {
  const {item, type, onClickComment, togglePickerModal, feedItemId = "feedItemId", viewType} = props
  const areReactionsEnabled = !!authentication.apps("recognition.recognition.reactions")
  const theme = useTheme()
  return (
    <Flex alignItems="center" gap={theme.spacing.oneAndHalf}>
      {type === RECOGNITION && <LikeButton parent={item} type={type} />}
      <AddRewardIcon item={item} type={type} />
      <CommentsIcon id={feedItemId} item={item} onClick={onClickComment} />
      {areReactionsEnabled && <ReactionList item={item} />}
      {areReactionsEnabled && <ReactionsIcon onClick={togglePickerModal} />}
      {type === RECOGNITION && viewType === RecognitionHubViews.CARD_VIEW && <ShareRecognition recognitionId={item?.uuid} />}
      {type === RECOGNITION && <RewardRecognitionAction item={item as Recognition} viewType={viewType} />}
    </Flex>
  )
}

export default Activity
